import { View } from 'ol';
import { mapStaticVariables } from '../model/StaticVariables';
import { useContext, useEffect } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { downloadString } from './DownloadString';
import { convertMapToImage } from './convertMapToImage';

const Downloader = (props) => {
    const { map, setSearch, setSelectedState, scope, tract } = useContext(InterfaceContext);
    const { filter, triggerDownload, onDownload, filename, restoreState, printState, dimensions = [11 * 71, 8 * 72], dpi } = props;
    useEffect(() => {
        //ΔVΔVΔ: Runs when pdf or filename is updated in props
        if (!triggerDownload) return;
        if (!map) return;

        downloadJPG({ map, filename, dimensions, dpi, restoreState, onDownload, printState, setSelectedState, scope, filter, tract });
    }, [triggerDownload, map]);
    return null;
};
export { Downloader };

const getWebDimensions = (map) => {
    return { resolution: map.getView().getResolution() * 1, width: map.getSize()[0], height: map.getSize()[1] };
};

const getPrintDimensions = (map, pageWidth, pageHeight, dpi = 72) => {
    const width = Math.round((pageWidth * dpi) / 35); //50 works well with a lot of states, but cuts some off
    const height = Math.round((pageHeight * dpi) / 35);
    const scaling = Math.min(width / map.getSize()[0], height / map.getSize()[1]);
    return { width: width, height: height, scaling };
};

const getPrintExtent = (filter, printState) => {
    if ((filter === 'current' || filter === 'state') && printState?.bounds?.length) {
        return printState.bounds;
    }
    return mapStaticVariables.extents.contiguous_us_and_pr;
};

const downloadJPG = (props) => {
    const { map, dpi = 72, filename = 'download.jpg', onDownload, restoreState = false, printState, filter, setSelectedState, dimensions = [72 * 10, 72 * 8], scope, tract } = props;

    //ΔVΔVΔ: Once map has rendered convert to jpg
    const createSendDownload = async () => {
        const addLegend = document.querySelector('[name=legendCheck]').checked;
        const addTitle = document.querySelector('[name=titleCheck]').checked;
        const mapImgUrl = await convertMapToImage(document.querySelector('#mapContainer'), print.width, print.height, addLegend, addTitle);
        downloadString(mapImgUrl, filename, false, (link) => {
            onDownload(link);
        });
    };

    // ΔVΔVΔ: Reset Map View to pre-print view
    const resoreMapView = () => {
        map.setSize([web.width, web.height]);
        map.setView(webView);
        // setSelectedState(restoreState);
    };

    //ΔVΔVΔ: Transform Map to print view
    const web = getWebDimensions(map);
    const print = getPrintDimensions(map, dimensions[0], dimensions[1], dpi);
    let webView = map.getView();
    var printView = new View({
        center: webView.getCenter(),
        projection: webView.getProjection(),
        zoom: webView.getZoom(),
        resolution: web.resolution / print.scaling,
        minZoom: 5,
        maxZoom: 15
    });

    //ΔVΔVΔ: Set map
    // map.setView(printView);
    // if (tract === 'county') {
    //     var ext = getPrintExtent(filter, printState);
    //     map.getView().fit(ext, map.getSize());
    // }

    // console.log('@@view set');
    // console.log('printState', printState);
    // console.log('the extent: ', ext);
    // console.log('@@fit set');

    //ΔVΔVΔ: Wait for map to be moved and positioned then change the usState
    map.once('rendercomplete', async function () {
        //ΔVΔVΔ: Wait for state to re-render
        // map.once('rendercomplete', () => {
        // setTimeout(async () => {
        await createSendDownload();
        resoreMapView(); //this isn't the zoom problem
        // });
        // });
        //ΔVΔVΔ: Initiate state render
        // setSelectedState(printState);
    });
    //ΔVΔVΔ: Initiate map rendering
    map.setSize([print.width, print.height]);
    console.log('@@size set');
};
export default downloadJPG;
// https://openlayers.org/en/latest/examples/export-pdf.html reference
